import { InGameMessage } from "../containers/TickerDisplay/Common/TickerDisplay.actions";
import { showError } from "../utils/errorHandler";

export const tickerMessage = (
  message: string | InGameMessage[],
  origin?: string
): boolean => {
  if (typeof message === "string") {
    if (message.length < 1) {
      showError("Ticker message has be at least 1 character", origin);
      return false;
    }
    return true;
  } else if (!Array.isArray(message)) {
    showError("Ticker message has be a string or an array of objects", origin);
    return false;
  } else if (message.length === 0) {
    showError("Array of Ticker messages cannot be empty", origin);
    return false;
  } else {
    let fail = false;

    if (message.some(m => typeof m !== "object")) {
      showError("Array of messages can only contain objects", origin);
      fail = true;
    } else {
      message.forEach((part, i) => {
        if (typeof part.text === "undefined") {
          showError(`Message ${i} text property is missing`, origin);
          fail = true;
        } else if (typeof part.text !== "string") {
          showError(`Message ${i} text property has to be a string`, origin);
          fail = true;
        } else if (part.text.length < 1) {
          showError(
            `Message ${i} text property has to have at least 1 character`,
            origin
          );
          fail = true;
        } else if (typeof part.url !== "undefined") {
          if (typeof part.url !== "string") {
            showError(`Message ${i} url property has to be a string`, origin);
            fail = true;
          } else if (part.url.length < 1) {
            showError(
              `Message ${i} url property has to have at least 1 character`,
              origin
            );
            fail = true;
          }
        }
      });
    }
    return !fail;
  }
};
